import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveAppInvitationMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type RemoveAppInvitationMutation = { __typename?: 'Mutation', removeAppInvitation: { __typename?: 'AppInvitation', id: string } };


export const RemoveAppInvitationDocument = gql`
    mutation RemoveAppInvitation($id: String!) {
  removeAppInvitation(id: $id) {
    id
  }
}
    `;
export type RemoveAppInvitationMutationFn = Apollo.MutationFunction<RemoveAppInvitationMutation, RemoveAppInvitationMutationVariables>;

/**
 * __useRemoveAppInvitationMutation__
 *
 * To run a mutation, you first call `useRemoveAppInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAppInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAppInvitationMutation, { data, loading, error }] = useRemoveAppInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAppInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAppInvitationMutation, RemoveAppInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAppInvitationMutation, RemoveAppInvitationMutationVariables>(RemoveAppInvitationDocument, options);
      }
export type RemoveAppInvitationMutationHookResult = ReturnType<typeof useRemoveAppInvitationMutation>;
export type RemoveAppInvitationMutationResult = Apollo.MutationResult<RemoveAppInvitationMutation>;
export type RemoveAppInvitationMutationOptions = Apollo.BaseMutationOptions<RemoveAppInvitationMutation, RemoveAppInvitationMutationVariables>;